export default __webpack_public_path__ + "static/media/avatar-wally.49879269.png";